






















import { defineComponent, PropType } from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { CATEGORIES_ICON } from '@front-app/vendor/icon-definitions';
import CategoryButton from '../buttons/concrete/CategoryButton.vue';

export default defineComponent({
	components: {
		CategoryButton,
		FontAwesomeIcon,
	},
	props: {
		categories: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup() {
		return {
			iconProps: CATEGORIES_ICON,
		};
	},
});
